import React from 'react';

import MarketVision from '../../components/Analyzing/MarketVision';

function MarketVisionView() {
  return (
    <MarketVision />
  );
}

export default MarketVisionView;
